import {
  Anchor,
  AudioLines,
  Building2,
  FileSignature,
  GalleryHorizontalEnd,
  HatGlasses,
  Layers,
  Newspaper,
  Palette,
  Rainbow,
  Sparkles,
  Waypoints,
  Wrench,
} from 'lucide-react';

import { IMenu } from '@shaojiang/types/common';

const menus: IMenu[] = [
  {
    title: 'Profile',
    i18nKey: 'profile',
    icon: HatGlasses,
    href: '/',
  },
  {
    title: 'Projects',
    i18nKey: 'projects',
    icon: Layers,
    href: '/projects',
  },
  {
    title: 'Articles',
    i18nKey: 'articles',
    icon: Newspaper,
    href: '/articles',
  },
  {
    title: 'Tools',
    i18nKey: 'tools',
    icon: Wrench,
    href: '/tools',
    subMenus: [
      { title: 'Color Picker', icon: Palette, href: '/color-picker', i18nKey: 'colorPicker' },
      { title: 'Svg2Base64', icon: Anchor, href: '/svg2base64', i18nKey: 'svg2Base64' },
    ],
  },
  {
    title: 'Showcases',
    i18nKey: 'showcases',
    icon: Rainbow,
    href: '/showcases',
    subMenus: [
      {
        title: 'Panorama Image Viewer',
        icon: GalleryHorizontalEnd,
        href: '/panorama',
        i18nKey: 'panoramaImageViewer',
      },
      { title: 'Audio Player', icon: AudioLines, href: '/audio-player', i18nKey: 'audioPlayer' },
      { title: 'Enterprise', icon: Building2, href: '/enterprise', i18nKey: 'enterprise' },
      { title: 'Form', icon: FileSignature, href: '/form', i18nKey: 'form' },
      { title: 'Fancy Border', icon: Sparkles, href: '/fancy-border', i18nKey: 'fancyBorder' },
      {
        title: 'Flowing Dashed Lines',
        icon: Waypoints,
        href: '/flowing-dashed-lines',
        i18nKey: 'flowingDashedLines',
      },
    ],
  },
];

export default menus;
